module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "fullpage"
    }
  }, [_vm._m(0), _vm._v(" "), _c('section', {
    staticClass: "section-padding8 section"
  }, [_c('div', {
    staticClass: "container ipahzhb"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "tablea"
  }, _vm._l((_vm.huobanlist), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "xintablea"
    }, [_c('a', {
      attrs: {
        "href": '/huoban?id=' + item.id + '&name=PARTNERS',
        "target": "_blank"
      }
    }, [_c('img', {
      staticClass: "donghuasunfadeIn",
      staticStyle: {
        "animation-duration": "1s",
        "animation-delay": "0.6s"
      },
      attrs: {
        "src": _vm.newurl + item['ico']
      }
    })])])
  }), 0)])]), _vm._v(" "), _c('section', {
    staticClass: "footer-area section-padding9 section"
  }, [_c('div', {
    staticClass: "footer-widget"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xl-5 offset-xl-1 col-lg-6"
  }, [_c('div', {
    staticClass: "single-widget-home mb-5 mb-lg-0 donghuaLeft phone_weibu_kd",
    staticStyle: {
      "animation-duration": "0.5s",
      "animation-delay": "0.3s"
    }
  }, [_c('h3', {
    staticClass: "mb-4 phone_weibu_zt1",
    staticStyle: {
      "font-weight": "500",
      "font-size": "40px"
    }
  }, [_vm._v("专业技术团队 提供全方位系统解决方案")]), _vm._v(" "), _c('p', {
    staticClass: "mb-4",
    staticStyle: {
      "color": "#7a7a7a",
      "line-height": "60px"
    }
  }, [_vm._v("如有任何疑问 请随时与我们联系")]), _vm._v(" "), _c('form', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messname),
      expression: "messname"
    }],
    attrs: {
      "type": "messname",
      "placeholder": "您的姓名",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的姓名'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messname)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messname = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtel),
      expression: "messtel"
    }],
    attrs: {
      "type": "messtel",
      "placeholder": "您的电话",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的电话'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtel)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtel = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.messtitle),
      expression: "messtitle"
    }],
    attrs: {
      "type": "messtitle",
      "placeholder": "您的留言",
      "onfocus": "this.placeholder = ''",
      "onblur": "this.placeholder = '您的留言'",
      "required": ""
    },
    domProps: {
      "value": (_vm.messtitle)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.messtitle = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "template-btnb",
    staticStyle: {
      "background": "rgb(0 100 207)"
    },
    attrs: {
      "type": "submit"
    },
    on: {
      "click": _vm.buttonmess
    }
  }, [_vm._v("立即提交")])])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "footer-copyright weibu_sun"
  }, [_c('div', {
    staticClass: "container weibu912",
    staticStyle: {
      "padding-top": "50px"
    }
  }, [_vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "weibu_c donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.5s"
    }
  }, [_c('p', [_vm._v(_vm._s(_vm.zhandianinfo.copyright))]), _vm._v(" "), _c('p', [_vm._v("总部公司 : " + _vm._s(_vm.qiyeinfo.address))]), _vm._v(" "), _c('p', [_vm._v("服务热线 : " + _vm._s(_vm.qiyeinfo.mobile))]), _vm._v(" "), _c('p', [_vm._v("主营产品 : " + _vm._s(_vm.qiyeinfo.other))]), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.zhandianinfo.icp) + " "), _vm._m(4)])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "map-area section-padding hezuo_section1 section"
  }, [_c('div', {
    staticClass: "banner-sun"
  }, [_c('p', {
    staticClass: "p1 animate fadeInDown animated jjfangan_zt1",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "0.1s",
      "visibility": "visible"
    }
  }, [_vm._v("合作伙伴")]), _vm._v(" "), _c('p', {
    staticClass: "p2 animate zoomIn animated jjfangan_zt2",
    staticStyle: {
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible",
      "color": "#E91E63"
    }
  }, [_vm._v("PARTNERS")])]), _vm._v(" "), _c('div', {
    staticClass: "animate bounce animated",
    staticStyle: {
      "width": "100%",
      "height": "100px",
      "line-height": "100px",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "1s",
      "visibility": "visible"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/shubiao.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "donghuasun hezuokuandu",
    staticStyle: {
      "width": "100%",
      "height": "120px",
      "text-align": "center",
      "animation-duration": "1s",
      "animation-delay": "0.3s"
    }
  }, [_c('p', {
    staticStyle: {
      "font-size": "30px",
      "color": "#44BCB9"
    }
  }, [_vm._v("PARTNERS")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "24px",
      "color": "#666666"
    }
  }, [_vm._v("战略合作伙伴")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_a donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.3s"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/assets/images/logob.png"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "image-counter"
  }, [_c('div', {
    staticClass: "image-containerc"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containera"
  }), _vm._v(" "), _c('div', {
    staticClass: "image-containerb"
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "weibu_b donghuasun",
    staticStyle: {
      "animation-duration": "0.6s",
      "animation-delay": "0.4s"
    }
  }, [_c('p', [_vm._v("工业物联网整体解决方案服务商")]), _vm._v(" "), _c('p', [_vm._v("智能传感解决方案专家")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('i', [_c('img', {
    staticStyle: {
      "width": "16px",
      "height": "16px",
      "margin-bottom": "5px"
    },
    attrs: {
      "src": "/static/assets/images/gongan.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-05ac1495"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/JobSingle.vue
// module id = 100
// module chunks = 0